import {Resource} from '~/helpers/prices/cdn/enum'
import {MB_IN_GB} from '~/helpers/constants'

const AKAMAI_MB_IN_GB = 1000

const Unit = {
  MB: 'MB',
  MB_H: 'MB*H',
  GB: 'GB',
  GB_H: 'GB*H'
}

export const assignPrices = (prices, clonePrices, keys) => {
  return prices.map(price => {
    const clonePrice = clonePrices.find(clonePrice => {
      return keys.reduce((isEqualPrice, key) => {
        return isEqualPrice && price[key] === clonePrice[key]
      }, true)
    })

    return {...clonePrice, ...price}
  })
}

export const getFetchDate = () => {
  const date = new Date()
  const month = (date.getMonth() + 1).toString()
  const day = date.getDate().toString()
  return `${day.length === 1
    ? '0'
    : ''}${day}.${month.length === 1
    ? '0'
    : ''}${month}.${date.getFullYear()}`
}

export const fetchSynchronizer = async(commit, state) => {
  while (!state.fetchingResult) {
    const checker = await new Promise(resolve => {
      setTimeout(() => resolve(), 100)
    })
  }
  return state.fetchingResult === 'good'
    ? Promise.resolve()
    : Promise.reject(state.fetchingResult)
}

export const fetchSuccessful = commit => {
  commit('setFetchingState', false)
  commit('setFetchingResult', 'good')
}

export const fetchStart = commit => {
  commit('setFetchingState', true)
  commit('setFetchingResult', '')
}

export const fetchErrorsHandler = (commit, err) => {
  commit('setFetchingState', false)
  commit('setFetchingResult', err)

  console.log(err)
  return Promise.reject(err)
}

export const checkPricesWarnings = prices => {
  try {
    prices.forEach(price => {
      if (!price.name) console.error(price)
       const check = price.name.ru
    })
    return Promise.resolve(prices)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const switchMbToGb = prices => {
  return prices.map(price => {
    const isAkamaiResource = (
      price.resource === Resource.AKAMAI_TRAFFIC_MB ||
      price.resource === Resource.AKAMAI_TRAFFIC_CUSTOM_MB
    )

    switch (price.unit) {
      case Unit.MB:
        price.unit = Unit.GB
        price.value *= isAkamaiResource
          ? AKAMAI_MB_IN_GB
          : MB_IN_GB

        break

      case Unit.MB_H:
        price.unit = Unit.GB_H
        price.value *= MB_IN_GB

        break
    }

    return price
  })
}

export const filterByValues = (prices, options) => {
  let filteredPrices = prices
  options.forEach(option => {
    filteredPrices = filteredPrices.filter(price => option.values.indexOf(price[option.key]) > -1)
  })

  return filteredPrices
}

/**
 * Уточняет стоимость за количество места, занятого бэкапами клиента в Облаке на базе VMware
 * @link https://jira.selectel.org/browse/WEB-347
 * @param prices
 */
export const specifyVbrBackupsStoragePrices = prices => prices.map(price => {
  if (price.resource === 'vbr_backups_storage') {
    price.value = 0.13697129081744466
  }
  return price
})